import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReferencesPanelComponent } from './references-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
    

@NgModule({
  declarations: [ReferencesPanelComponent],
  exports: [ReferencesPanelComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
})
export class ReferencesPanelModule { }
